import React, { FC } from 'react';

import { Link } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import { FundsAssociatedInvestor } from 'interfaces/funds.interfaces';
import { TableData, TableRow } from 'shared-components/table';

type Props = {
  investor: FundsAssociatedInvestor;
};

const AssociatedInvestorsTableRow: FC<Props> = ({ investor }) => {
  const procentageShare = Math.round(Number(investor.percentageShare) * 100 * 100) / 100;
  const id = investor.id;

  return (
    <TableRow>
      <TableData>{investor.investorName}</TableData>
      <TableData>
        <Link className='text-violet-600' to={`${ROUTES.admin}${ROUTES.investor}`.replace(':id', id.toString())}>
          {investor.investorEmail}
        </Link>
      </TableData>
      <TableData>{investor.totalShares}</TableData>
      <TableData>£{investor.totalCurrentValue}</TableData>
      <TableData>£{investor.averagePricePerShare}</TableData>
      <TableData>{procentageShare}%</TableData>
    </TableRow>
  );
};

export default AssociatedInvestorsTableRow;
